import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "onSend", "toolbar"];
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import { BreezeButton } from '../buttons/BreezeButton';
import AICopilotTextInput from './AICopilotTextInput';
import { jsx as _jsx } from "react/jsx-runtime";
const ToolbarContainer = styled.div.withConfig({
  displayName: "AISendInput__ToolbarContainer",
  componentId: "la1jil-0"
})(["display:flex;gap:4px;align-items:center;transition:opacity 0.2s ease;"]);
const AISendInput = _ref => {
  let {
      disabled = false,
      onSend,
      toolbar
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const hasToolbar = Boolean(toolbar);
  return /*#__PURE__*/_jsx(AICopilotTextInput, Object.assign({}, props, {
    icon: /*#__PURE__*/_jsx("div", {
      style: {
        position: 'absolute',
        bottom: '7px',
        right: '9px'
      },
      children: /*#__PURE__*/_jsx(BreezeButton, {
        "data-test-id": "chat-send-button",
        name: "send",
        shape: "circle",
        onClick: onSend,
        size: "xs",
        disabled: disabled,
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "breezeSend"
        })
      })
    }),
    toolbar: hasToolbar ? /*#__PURE__*/_jsx(ToolbarContainer, {
      children: toolbar
    }) : null
  }));
};
export default AISendInput;